import React, { useRef, useEffect, useState, useLayoutEffect } from 'react';
//import { ReactComponent as EspoBuildLogo } from '../assets/espobuild-o.svg';
import EspoBuiltLogo from '../web_elements/espobuilt_logo_500.png';
import BlueDecorativeStripe from '../web_elements/decorative_stripe_full.png';
import "../styles/EspoBuiltHeader.css";
import { ReactComponent as DecorationHeader } from '../web_elements/decoration1-o.svg';
const EspoBuiltHeader = () => {
    const logoRef = useRef(null);
    const [paddingTop, setPaddingTop] = useState();
    useEffect(() => {
        if (logoRef.current) {
            setTimeout(() => {
                const logoHeight = logoRef.current.getBoundingClientRect().height;
                //console.log("Logo height:", logoHeight);
                setPaddingTop(logoHeight * 1.2); // 120% of the logo's height
            }, 0); // Minimal delay to ensure DOM readiness
        }
    }, []);
    return (
        <div className="EspoBuiltHeader-component">
            <img className="EspoBuilt-logo"
                 ref={logoRef}
                 src={EspoBuiltLogo}
                 alt=""></img>
            <DecorationHeader className="BlueDecorativeStripe"
                              style={{
                              }}
            />
        </div>
    )
}
export default EspoBuiltHeader;